import React from 'react';
import '../../styles/AvvisoCfVecchio.css';

/**
 * AvvisoCfVecchio — «documento emesso col codice fiscale vecchio», e accanto
 * al documento le tracce della correzione (Alex, 4/10/2026; migration 297).
 *
 * PERCHE' C'E'. Il documento emesso non cambia mai, nemmeno quando
 * l'amministrazione corregge il codice fiscale dell'intestatario: di una
 * fattura non ancora trasmessa al Sistema TS cambia SOLO il codice che
 * partira'. Chi ristampa o consegna quel documento deve sapere che porta il
 * codice vecchio, e perche': lo dicono l'avviso, in cassa e nell'elenco dei
 * documenti, e le tracce «CF trasmesso, corretto il <data> da <utente>,
 * motivo <motivo>», una per correzione.
 *
 * DA DOVE VIENE. Il server manda `cf_vecchio` (documento_col_cf_vecchio) e
 * `tracce_cf_ts` (tracce_cf_al_ts), composte dal database: qui non si decide
 * niente e non si compone niente, per non avere una seconda copia della
 * regola o della frase.
 *
 * `conTracce`: nel documento aperto le tracce si leggono per intero sotto
 * l'avviso (e restano anche se l'avviso non c'e'); negli elenchi stanno nel
 * suggerimento dell'avviso, per non allungare le righe.
 */
export const AVVISO_CF_VECCHIO = 'documento emesso col codice fiscale vecchio';

const AvvisoCfVecchio = ({ fattura, conTracce = false }) => {
    const tracce = Array.isArray(fattura?.tracce_cf_ts) ? fattura.tracce_cf_ts.filter(Boolean) : [];
    const avviso = fattura?.cf_vecchio === true;
    if (!avviso && !(conTracce && tracce.length)) return null;
    return (
        <span className="cfv" data-segno="cf-vecchio">
            {avviso && (
                <span className="rm-stato rm-stato-attenzione cfv-avviso" title={tracce.join('\n') || undefined}>
                    {AVVISO_CF_VECCHIO}
                </span>
            )}
            {conTracce && tracce.map((t, i) => (
                <span key={i} className="cfv-traccia">{t}</span>
            ))}
        </span>
    );
};

export default AvvisoCfVecchio;
